import { SHOW_NOTIF } from "./actionType";

export const showNotif = (payload) => ({ type: SHOW_NOTIF, payload });
